import React from 'react'
import { Bar } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js'

const HRChart = ({ data }) => {
  ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend)

  const { employee_exit_array, employee_added_array, months } = data

  const formattedMonths = months.map((month) => {
    const date = new Date(`${month}-01`)
    return date.toLocaleString('default', { month: 'short' })
  })

  const chartData = {
    labels: formattedMonths,
    datasets: [
      {
        label: 'Employees Added',
        data: employee_added_array,
        backgroundColor: 'rgba(23, 147, 66, 0.6)',
        barThickness: 17,
        borderRadius: 8,
        barPercentage: 0.4,
        categoryPercentage: 0.7,
      },
      {
        label: 'Employees Exited',
        data: employee_exit_array,
        backgroundColor: ' rgba(23, 147, 66, 0.2)',
        barThickness: 17,
        borderRadius: 8,
        barPercentage: 0.4,
        categoryPercentage: 0.7,
      },
    ],
  }
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: '#fff',
        titleFont: { size: 14, weight: 'bold', family: 'Arial', color: '#000' },
        bodyFont: { size: 12, family: 'Arial', color: '#000' },
        padding: 10,
        displayColors: false,
        borderWidth: 1,
        borderColor: '#ddd',
        cornerRadius: 6,
        titleColor: '#000',
        bodyColor: '#000',
        callbacks: {
          title: (tooltipItems) => `Month: ${tooltipItems[0].label}`,
          label: (tooltipItem) => {
            return `${tooltipItem.dataset.label}: ${tooltipItem.raw}`
          },
        },
      },
      legend: {
        position: 'bottom',
        align: 'end',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          boxWidth: 10,
          color: '#000',
        },
      },
    },
    scales: {
      x: {
        grouped: true,
      },
      y: {
        ticks: {
          stepSize: 1,
          precision: 0,
          color: '#000',
        },
      },
    },
  }
  return (
    <div className='flex h-full'>
      <Bar data={chartData} options={options} />
    </div>
  )
}

export default HRChart
